export const SMART_COLIS_TRACKING_SHIPPING_OR_COLIS_PATTERN = /^[a-zA-Z0-9]{1,}-[a-zA-Z0-9]{1,}(-[a-zA-Z0-9]{1,})*$/;
export const SMART_COLIS_TRACKING_COLIS_PATTERN = /^[a-zA-Z0-9]{1,}-[a-zA-Z0-9]{1,}-[a-zA-Z0-9]{1,}$/;
export const SMART_COLIS_TRACKING_SHIPPING_PATTERN = /^[a-zA-Z0-9]{1,}-[a-zA-Z0-9]{1,}$/;

export const isShippingTracker = (trackerId: string): boolean => {
  return SMART_COLIS_TRACKING_SHIPPING_PATTERN.test(trackerId);
};

export const isColiTracker = (trackerId: string): boolean => {
  return SMART_COLIS_TRACKING_COLIS_PATTERN.test(trackerId);
};
